/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Product Price related scripts

define('modules/Product/ProductDetails',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    function reload(viewModel) {
        $('*[data-element-type="productTitle"]').html(superscript(viewModel.name));
        
        if (viewModel.productType === 'Simple') {
            $('.itemSku').html('Item #: <span itemprop="sku">' + viewModel.sku + '</span>');
        } else {
            $('.itemSku').empty();
        }

        var vendorSku = Roc.Core.getCustomValue(viewModel, 'vendorSKU');
        if (vendorSku) {
            $('.vendorSku').html('Vendor SKU: ' + vendorSku);
        } else {
            $('.vendorSku').empty();
        }

        if (viewModel.productType === 'Simple') {
            $('.short-description').html(superscript(viewModel.shortDescription));
        } else {
            $('.short-description').empty();
        }

        var $QuoteBtn = $('#QuoteBtn[href*=\'ProductId\']');
        if ($QuoteBtn.length > 0) {
            var href = $QuoteBtn.attr('href');
            $QuoteBtn.attr('href', href.substring(0, href.indexOf('=') + 1) + viewModel.id);
        }


    }

    function superscript(text) {
        if (text && typeof text === "string") {
            $.each(window.RocConfig.superscriptCharacters, function (index, value) {
                text = text.replace(new RegExp(value, 'g'), '<sup>' + value + '</sup>');
            });
        }

        return text;
    }

    function init() {
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reload);
    }

    var ProductDetails = {
        init: init
    }

    Roc.Logger.debug('ProductPrice.js Loaded:', ProductDetails);

    return ProductDetails;
});
